import { useEffect } from 'react';

/**
 * Hook para bloquear el scroll del body cuando un modal está abierto
 * Previene que el contenido de fondo se mueva al hacer scroll
 * 
 * @param {boolean} isLocked - Si true, bloquea el scroll del body
 */
export function useBodyScrollLock(isLocked) {
  useEffect(() => {
    if (isLocked) {
      // Guardar el scroll actual
      const scrollY = window.scrollY;
      
      // Bloquear scroll
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
    } else {
      // Restaurar scroll
      const scrollY = document.body.style.top;
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      
      // Restaurar posición de scroll
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }

    // Cleanup al desmontar
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
    };
  }, [isLocked]);
}
